import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { GiftItemRow } from '@models/gift';
import { useTranslation } from 'react-i18next';

import InfoIcon from './InfoIcon';
import SearchIcon from './SearchIcon';

interface Props {
    gitItem: GiftItemRow;
}

function ItemInfo({ gitItem }:Props) {
    const {
        status, name, imageUrl, description,
    } = gitItem;
    const { t } = useTranslation('gift');
    return (
        <Container as='section' fullWidth
            spacing={12}
            align='center'>
            <ImageContainer>
                <Image src={imageUrl}
                    width={100}
                    height={100}
                    alt=''/>
                {status === 'SOLD_OUT' && (
                    <SoldOut>
                        {t('item.soldOut')}
                    </SoldOut>
                )}
            </ImageContainer>
            <Text size='3xl' fontWeight='bold'>
                {name}
            </Text>
            {description && (
                <Text>{description}</Text>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    flex: 1;
    padding: 32px 20px;
`;

const ImageContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    position: relative;
`;

const SoldOut = styled.div`
    background: linear-gradient(0deg, rgba(196, 131, 114, 0.16) 0%, rgba(196, 131, 114, 0.16) 100%), rgba(255, 255, 255, 0.65);
    color: var(--color-gray7);
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    padding: 8px 10px;
    position: absolute;
    transform: rotate(-18deg);
`;

export default ItemInfo;
